import { render, staticRenderFns } from "./ServicioNuevo.vue?vue&type=template&id=23abd352"
import script from "./ServicioNuevo.vue?vue&type=script&lang=js"
export * from "./ServicioNuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports